import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';

import { ConfirmImportDialogData } from '../project-imports.interface';

@Component({
  host: { 'test-id': 'confirm-import-dialog' },
  selector: 'confirm-import-dialog',
  styleUrls: ['./confirm-import-dialog.component.scss'],
  templateUrl: './confirm-import-dialog.component.html',
})

export class ConfirmImportDialog {
  constructor(
    @Inject(DIALOG_DATA) public data: ConfirmImportDialogData,
    public dialogRef: DialogRef<boolean, ConfirmImportDialog>,
  ) { }
}
